angular.module('unica_archive_event.archive_event_services')

.factory('ArchiveEventListService', function ($http, getBaseApiURL) {

	var archiveEventListService = {};

	archiveEventListService.years = function () {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event/years',
			data: {
				archive: true
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.years;
			}

		});

	};

	archiveEventListService.list = function (year, limit, offset) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event/list',
			data: {
				year: year,
				limit: limit,
				offset: offset,
				archive: true
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.events;
			}

		});

	};


	archiveEventListService.get = function (eventId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event/detail/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.event;
			}

		});
	};


	archiveEventListService.getStagesList = function (eventId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event/list-stages/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.stages;
			}

		});
	};


	return archiveEventListService;
});